import http from '@/communication/AuthConnection'
export default async ({ commit }, { documentId }) => {
  try {
    const { status } = await http.delete(`/v1/documents/remove-by-id/${documentId}`)
    if (status !== 200) {
      return Promise.reject(Error('Não conseguimos remover o arquivo'))
    }
    return true
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/brain/event-documents/RemoveDocumentById.js